export default __webpack_public_path__ + "static/media/app-store.2c6a269c.svg";